import { createActions } from "../../helpers/utils/createActions";
import { TEMPLATE } from "./actionTypes";

export const getListaTemplate = createActions(TEMPLATE.GET_LIST)
export const getTemplate = createActions(TEMPLATE.GET_TEMPLATE)
export const saveTemplate = createActions(TEMPLATE.SAVE_TEMPLATE)

export const getTemplateHistory = createActions(TEMPLATE.GET_TEMPLATE_HISTORY)
export const getTemplateHistoryList = createActions(TEMPLATE.GET_TEMPLATE_HISTORY_LIST)
export const getTemplateAll = createActions(TEMPLATE.GET_TEMPLATE_ALL)

export const loadEmptyTemplate = () => ({ type: TEMPLATE.LOAD_EMPTY, });
export const cleanMessageTemplate = () => ({ type: TEMPLATE.CLEAN_MESSAGE, });
export const changePageSizeTemplate = (payload) => ({ type: TEMPLATE.CHANGE_PAGE_SIZE_TEMPLATE, payload });